import { createApp } from 'vue';
import FontAwesomeIcon from '@/utils/fontawensome';
import i18n from '@/utils/language/i18n';
import vSelect from 'vue-select';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/css/tailwind.css';
import '@/assets/css/global.css';
import 'vue-select/dist/vue-select.css';

createApp(App).use(store).use(router).use(i18n)
  .component('font-awesome-icon', FontAwesomeIcon)
  .component('v-select', vSelect)
  .mount('#app');
